/**
 * Wrapper class for identifying network errors between backend resource server and local agent server.
 */
export class NetworkError extends Error {
  readonly errorType: 'RESOURCE' | 'AGENT';

  constructor(error: Error, type: 'RESOURCE' | 'AGENT') {
    super(error.message);
    this.name = type + 'Error';
    this.errorType = type;
  }
}
